export * from './src/captcharator-v1-captcha-entity-captcha.universal.js';
